import SectionRoute from "@dashboard/auth/components/SectionRoute";
import { PermissionEnum } from "@dashboard/graphql";
import { type RouteProps } from "react-router-dom";

import AtticInventorySection from "./index";

/** Reading the inventory is its own grant; writes are gated per mutation. */
export const ATTIC_INVENTORY_PERMISSIONS = [PermissionEnum.VIEW_INVENTORY];

/**
 * The section's route, gated on VIEW_INVENTORY. Here rather than inline in
 * src/index.tsx so the gate can be tested. Give it `path` where it is used.
 */
export const AtticInventoryRoute = (props: RouteProps) => (
  <SectionRoute
    {...props}
    permissions={ATTIC_INVENTORY_PERMISSIONS}
    component={AtticInventorySection}
  />
);
